import { Link } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import HomeNavbar from "../../Components/HomeNavbar/HomeNavbar";
import FeaturesCard from "./components/FeaturesCard";
import styles from "./Employer.module.css";
import clsx from "clsx";
import { useEffect } from "react";
import Chatbot from "../../Components/Chabot/Chatbot";
import SEOHead from "../../Components/SEOHead/SEOHead";
import { getSEOByPath } from "../../config/seoConfig";
import { useRegion } from "../../context/RegionContext";
import { REGIONS } from "../../constants/regions";
import { images } from "../../assets/images";
import heroImageKSA from "../../assets/ksa/Hero_Section_KSA.png";
import reactangle from "../../assets/ksa/Rectangle_29532_KSA.png";
import jobseekerImg from "../../assets/ksa/For_Jobseekers_KSA.png";

const EmployerPage = () => {
  const seoData = getSEOByPath("/");
  const { region } = useRegion();

  useEffect(() => {
    window.scrollTo(0, 0); // This will scroll the page to the top
  }, []);

  const appStore = () => {
    window.open(
      "https://apps.apple.com/ae/app/falek-tayyeb/id6471679752",
      "_blank"
    );
  };
  const playStore = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.falektayyeb.ft&hl=en",
      "_blank"
    );
  };

  return (
    <div className={styles.container}>
      {seoData && (
        <SEOHead
          title={seoData.title}
          description={seoData.description}
          canonical={seoData.canonical}
        />
      )}
      <HomeNavbar isHome={true} />
      <div className={styles.homeContent}>
        <section id="hero" className={styles.heroSection}>
          <div className={styles.heroContent}>
            <div className={styles.pageHolder}>For Employers</div>
            <h1 className={styles.heroText}>
              Connecting You with Exceptional{" "}
              {region === REGIONS.AE ? "Emirati" : "Saudi"} Talent for Your
              Hiring Needs.
            </h1>
            <div className={clsx(styles.heroDesc, styles.greyText)}>
              Brought to you{" "}
              <img src={images.tascBlueLogo} />
            </div>
            <Link to={"/signup"} style={{ textDecoration: "none" }}>
              <div className={styles.gradientBtn}>
                Get Your Free Access Now!{" "}
                <img src={images.btnArrow} />
              </div>
            </Link>
          </div>
          <div className={styles.heroimgHolder}>
            <img
              src={
                region === REGIONS.AE
                  ? images.newImgHero
                  : heroImageKSA
              }
              className={styles.heroImage}
            />
          </div>
        </section>
        <div className={styles.featuresSection}>
          <h2 className={styles.featuresHeader}>
            Try our limited-time complimentary trial ⏰
          </h2>
          <div className={styles.featureCards}>
            <FeaturesCard
              icon={images.connectWith}
              title={`Connect with ${
                region === REGIONS.AE ? "Emiratis" : "Saudis"
              }`}
              description={
                region === REGIONS.AE
                  ? "Post UAE National jobs and receive active Emirati job seekers with friendly and easy interface."
                  : "Post KSA National jobs and receive active Saudi job seekers with friendly and easy interface."
              }
            />
            <FeaturesCard
              icon={images.hireTalents}
              title={`Hire ${
                region === REGIONS.AE ? "Emirati" : "Saudi"
              } Talents`}
              description="Sourcing, interviewing, coordination with teammates, offers, and onboarding by TASC"
            />
            <FeaturesCard
              icon={images.jobHub}
              title="Create Your Job Hub"
              description="Create a dedicated job space for your organization on the Forsatak platform."
            />
          </div>
        </div>
        <div className={styles.ctaSection}>
          <img
            src={
                region === REGIONS.AE
                ? images.freeAccessImgNew
                : reactangle
            }
            className={styles.ctaImage}
          />
          <div className={styles.ctaContent}>
            <h2>
              Reach out to a diverse pool of more than{" "}
              <span className={styles.gradientText}>3,500</span>{" "}
              {region === REGIONS.AE ? "Emirati" : "Saudi"} candidates from all
              career levels.
            </h2>
            <Link to={"/signup"} style={{ textDecoration: "none" }}>
              <div className={styles.gradientBtn}>
                Get Your Free Access Now!{" "}
                <img src={images.btnArrow} />
              </div>
            </Link>
          </div>
        </div>
        <div className={styles.gradientSection}>
          <div className={styles.topLeft}></div>
          <div className={styles.bottomRight}></div>
          <div className={styles.heroContent}>
            <h2>Start posting your jobs today</h2>
            <div className={styles.heroDesc}>
              Post Unlimited {region === REGIONS.AE ? "Emirati" : "Saudi"} Jobs
              For Free!
            </div>
            <Link to={"/signup"} style={{ textDecoration: "none" }}>
              <div className={styles.whiteBtn}>Get Your Free Access Now! </div>
            </Link>
          </div>
          <img
            src={images.dashboardSnippetNew}
            className={clsx(styles.dashboardImg, styles.hideInMobile)}
          />
          <div className={styles.centerImgMobile}>
            <img
              src={images.dashboardSnippetMobile}
              className={clsx(styles.dashboardImg, styles.hideInDesktop)}
            />
          </div>
        </div>
        <div className={styles.employeeSection}>
          <div className={styles.employeeLeft}>
            <img
              src={
                region === REGIONS.AE
                  ? images.jobseekers
                  : jobseekerImg
              }
              className={styles.employeeImg}
            />
            <div className={styles.empContent}>
              <Link to={"/jobseeker"} style={{ textDecoration: "none" }}>
                <div className={styles.empTag}>For Jobseekers</div>
              </Link>
              <h2 className={styles.featureTitle}>
                Are you a {region === REGIONS.AE ? "UAE" : "KSA"} National?
              </h2>
              <p className={styles.featureDesc}>
                Looking for jobs? Download the JS app Now!
              </p>
              <Link
                target="_blank"
                to={"/jobseeker"}
                style={{ textDecoration: "none" }}
              >
                <p className={styles.gradientLink}>Learn More</p>
              </Link>
            </div>
          </div>
          <div className={styles.employeeRight}>
            <img
              onClick={appStore}
              src={images.appstore}
              className={styles.downloadImg}
            />
            <img
              onClick={playStore}
              src={images.playstore}
              className={styles.downloadImg}
            />
          </div>
        </div>
      </div>
      <Chatbot />
      <Footer />
    </div>
  );
};

export default EmployerPage;
